import { JwtInterceptor } from './jwt.interceptor';
import { AuthInterceptor } from 'app/core/auth/auth.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsService } from '../comments/comments.service';
@NgModule({
    declarations: [],
    imports: [HttpClientModule],
    providers: [],
})
export class JwtModule {}
